<template>
    <b-modal  id="modalItemInventario" ref="modal-item-inventario" size="xl" v-model="exibirItens" :title="$t('Lançamento de item')" centered>
        <div class="col-12 col-md-10 mb-3">
            <span>Item</span>
            <input type="text" disabled class="form-control" :placeholder="$t('Item')" style="height: 53px;" v-model="dsItem">
        </div>
        <div class="col-12 row">
            <div class="col-6"> 
                <span>Qtd Item</span>
                <input disabled type="text" class="form-control" :placeholder="$t('Item')" style="height: 53px;" v-model="qtdItem">
            </div>
            <div class="col-6">
                <span>Contagem</span>
                <input type="number" class="form-control" :placeholder="$t('Item')" style="height: 53px;" v-model="contagemItem">
            </div>
        </div>
        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center;">
                    <b-button variant="danger" class="btn btn-outnline-danger mr-2" @click="$emit('closeModal')">
                        {{ $t('Cancelar') }}
                    </b-button>
                    <b-button size=" lg" variant="success" @click="confirmarContagem">
                        {{ $t('Confirmar') }}
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
/* eslint-disable */

export default {
    data() {
        return {
            exibirItens: true,
            dsItem: '',
            qtdItem: '',
            contagemItem: 0,
            itemSelected: ''
        }
    },
    props: {
        item: {}
    },

    methods: {
        itemSelecionado() {
            const item = this.$store.getters['inventario/getItemSelecionado']

            // if (!item) {
            //     this.$store.dispatch('inventario/searchItemQrCode', { codItem: this.item })

            //     return []
            // }
            this.itemSelected = item
            this.dsItem = item.ds_item
            this.qtdItem = Math.trunc(item.saldo_atual)
            // this.qtdItem = item.nr_qtidade_contagem
        },

        confirmarContagem() {
            const data = {
                nr_seq_inventario: this.$route.params.id,
                nr_seq_estoque: this.itemSelected.nr_sequencial,
                nr_qtidade_contagem: this.contagemItem
            }

            // if(data.nr_qtidade_contagem == 0) {
            //     this.$swal.fire({
            //         title: 'Ooops!',
            //         text: 'Insira uma quantidade!',
            //         icon: 'warning',
            //     })
            //     return false
            // }

            this.$store.dispatch('inventario/confirmarContagem', { data: data }).then(response => {
                this.$emit('closeModal')

                const data = {
                    nr_seq_inventario: this.$route.params.id
                }

                this.$store.dispatch('inventario/getItensInventario', { data: data })

                this.$swal.fire({
                    title: 'Sucesso!',
                    text: 'Item registrado com sucesso!',
                    icon: 'success',
                    timer: 1000
                })
            }).catch((error) => {
                    this.$swal.fire({
                    title: 'Ooops!',
                    text: 'Item não registrado, tente novamente!',
                    icon: 'error'
                }) 
            })
        }
    },

    created() {
        const data = {
            codItem: this.item,
            nr_seq_inventario: this.$route.params.id
        }
        this.$store.dispatch('inventario/searchItemQrCode', { data: data }).then(response => {
            this.itemSelecionado()
        })
    }
}
</script>
<style src="./style.css" lang="css"></style>